import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../../theme/css/theme.css";
import { RADIAL_MENU_OPTION_SIZE } from "./RadialMenuOption.motion";
import { transition } from "../../../utils/transition";

/**
 * Wrapper for each option button and its label.
 * Positioned absolutely at the center, then transformed via motion.
 * Offset by half the size so the element centers on the (0,0) point.
 * Z-index is applied via inline style based on hover order.
 * Focus outline is removed as the visual state change (expansion) indicates focus.
 */
export const optionWrapperStyle = style({
  position: "absolute",
  top: rem(-RADIAL_MENU_OPTION_SIZE / 2),
  left: rem(-RADIAL_MENU_OPTION_SIZE / 2),
  cursor: "pointer",
  height: rem(RADIAL_MENU_OPTION_SIZE),
  width: rem(RADIAL_MENU_OPTION_SIZE),
  outline: "none",
});

/**
 * Style for the option button itself.
 * Transforms from a circular icon button to a pill-shaped label on hover.
 */
export const optionButtonStyle = recipe({
  base: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    minHeight: rem(RADIAL_MENU_OPTION_SIZE),
    overflow: "hidden",
    whiteSpace: "nowrap",
    borderRadius: "999px",
    transition: transition("background-color", "color", "border-color"),
  },
  variants: {
    active: {
      true: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.onPrimary,

        border: `1px solid ${theme.colors.primary}`,
      },
      false: {
        backgroundColor: theme.colors.background,
        color: theme.colors.onBackground,
        border: `1px solid ${theme.colors.defaultBorder}`,
      },
    },
  },
  defaultVariants: {
    active: false,
  },
});

/**
 * Style for the icon wrapper inside the option button.
 */
export const optionIconStyle = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: rem(RADIAL_MENU_OPTION_SIZE - 2),
  height: rem(RADIAL_MENU_OPTION_SIZE - 2),
  overflow: "hidden",
});

/**
 * Vertical container for the label and optional subtitle.
 */
export const labelContainerStyle = style({
  paddingRight: rem(20),
  paddingBlock: rem(8),
  marginLeft: rem(-4),
});

/**
 * Style for the label text inside the option button.
 */
export const labelTextStyle = style({
  lineHeight: 1,
});

/**
 * Style for the subtitle text below the label.
 */
export const subtitleTextStyle = style({
  lineHeight: 1,
});
